
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// === Thunks ===

// Fetch branches
export const getBranches = createAsyncThunk(
    "customer/getBranches",
    async (superAdminId, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${API_URL}/get-branch`, {
                params: {
                    SuperAdminId: superAdminId,
                    limit: "all",
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return res.data.branches || [];
        } catch (error) {
            console.error("Branch Fetch Error:", error);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// Fetch roles
export const fetchRoles = createAsyncThunk(
    "customer/fetchRoles",
    async (_, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${API_URL}/all-roles`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return res.data.roles || [];
        } catch (error) {
            console.error("Roles Fetch Error:", error);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// // Submit customer
// export const submitCustomer = createAsyncThunk(
//   "customer/submitCustomer",
//   async (data, { getState, rejectWithValue }) => {
//     try {
//       const token = localStorage.getItem("authToken");
//       const { auth } = getState();
//       const { profile } = auth; // profile contains branchId, superAdminId

//       // merge form data with branchId & superAdminId
//       const payload = {
//         ...data,
//         branchId: profile?.branchId,
//         superAdminId: profile?.superAdminId,
//       };

//       const res = await axios.post(`${API_URL}/customers`, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       return res.data;
//     } catch (error) {
//       console.error("Submit Error:", error);
//       return rejectWithValue(error.response?.data?.message || error.message);
//     }
//   }
// );


// Submit customer
export const submitCustomer = createAsyncThunk(
    "customer/submitCustomer",
    async (data, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("authToken");

            const res = await axios.post(
                `${API_URL}/customers`,
                // `${API_URL}/customers/customizeId`, ///ye iifsn wale ke liye hai.....
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return res.data;
        } catch (error) {
            console.error("Submit Error:", error);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);


// === Slice ===
const customerSlice = createSlice({
    name: "customer",
    initialState: {
        branches: [],
        roles: [],
        loadingBranches: false,
        loadingRoles: false,
        loadingSubmit: false,
        errorBranches: null,
        errorRoles: null,
        errorSubmit: null,
        submitStatus: null, // 'success' | 'error' | null
    },
    reducers: {
        resetSubmitStatus: (state) => {
            state.submitStatus = null;
            state.errorSubmit = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Branches
            .addCase(getBranches.pending, (state) => {
                state.loadingBranches = true;
                state.errorBranches = null;
            })
            .addCase(getBranches.fulfilled, (state, action) => {
                state.loadingBranches = false;
                state.branches = action.payload;
            })
            .addCase(getBranches.rejected, (state, action) => {
                state.loadingBranches = false;
                state.errorBranches = action.payload || "Failed to fetch branches";
            })

            // Roles
            .addCase(fetchRoles.pending, (state) => {
                state.loadingRoles = true;
                state.errorRoles = null;
            })
            .addCase(fetchRoles.fulfilled, (state, action) => {
                state.loadingRoles = false;
                state.roles = action.payload;
            })
            .addCase(fetchRoles.rejected, (state, action) => {
                state.loadingRoles = false;
                state.errorRoles = action.payload || "Failed to fetch roles";
            })

            // Submit Customer
            .addCase(submitCustomer.pending, (state) => {
                state.loadingSubmit = true;
                state.submitStatus = null;
                state.errorSubmit = null;
            })
            .addCase(submitCustomer.fulfilled, (state) => {
                state.loadingSubmit = false;
                state.submitStatus = "success";
            })
            .addCase(submitCustomer.rejected, (state, action) => {
                state.loadingSubmit = false;
                state.submitStatus = "error";
                state.errorSubmit = action.payload || "Failed to submit customer";
            });
    },
});

export const { resetSubmitStatus } = customerSlice.actions;
export default customerSlice.reducer;
